import * as angular from "angular";
import {CleverMatchRootScope} from "../models/root.model";
import {LayoutInitService} from "../layout-init/layout-init.service";

export function initRun(app: angular.IModule) {
    /* @ngInject */
    app.run(function ($rootScope: CleverMatchRootScope, layoutInitService: LayoutInitService) {

        $rootScope.clearLoadingError = () => {
            $rootScope.loadingError = false;
        };

        $rootScope.$on("$routeChangeStart", function (event: angular.IAngularEvent, next: angular.route.IRoute,
                                                      current: angular.route.IRoute) {
            $rootScope.loadingError = false;
            //refresh scenario
            if (!current) {
                layoutInitService();
            }

            if (next.redirectTo === "/") {
                event.preventDefault();
            }
            if (next.resolve) {
                // Show a loading message until promises are resolved
                $rootScope.loadingView = true;
            }
        });

        $rootScope.$on("$routeChangeSuccess", function () {
            // Hide loading message
            $rootScope.loadingView = false;
        });

        $rootScope.$on("$routeChangeError", function () {
            // Hide loading message
            $rootScope.loadingView = false;
            $rootScope.loadingError = true;
        });
    });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/app-run/app.run.ts